/**
 * RESPONSIBILITY: put values into the {placeholders} of a string an editor wrote.
 *
 * "Showing 3 of 12" is one sentence, and a sentence is not three fields. Splitting it
 * into a prefix and a joining word makes it untranslatable and unwritable — the word
 * order is part of the sentence, and an editor must be able to change it.
 *
 * An unknown placeholder is left exactly as typed rather than blanked, so a typo shows
 * itself instead of quietly deleting part of the line.
 */
export function fill(template: string, values: Record<string, string | number>): string {
  return (template ?? '').replace(
    /\{(\w+)\}/g,
    (whole, key: string) => (key in values ? String(values[key]) : whole),
  );
}
